export const DEFAULT_CHANNEL_INDEX = 'defaultChannel';
export const DEFAULT_SOCIAL_INTEGRATION_ID_INDEX = 'defaultIntegration';
export const LAST_INTEGRATION_PROP = {
  label: 'Последняя интеграция',
  value: DEFAULT_SOCIAL_INTEGRATION_ID_INDEX,
};
